import { forwardRef, useMemo } from 'react';
import { Link } from 'react-router-dom';

import { Plus } from 'lucide-react'
import { Button, cn } from 'twyne-new.ui';

import { useGrid } from '@Components/Grid/context';

export const HeaderAddButton = forwardRef(({ to, children, className, ...props }, ref) => {
  const content = <>
    <Plus size={14} className='md:hidden' />
    <span className='hidden md:inline-flex items-center gap-1'>{children}</span>
  </>

  return <Button ref={ref} color='accent' size='lg' className={cn('max-md:p-2.5', className)} asChild={!!to} {...props}>
    {to ? <Link to={to}>{content}</Link> : content}
  </Button>
})

export function useGridBasePath() {
  const { definitions: { entityNameModule, entityNamePlural, basePath } } = useGrid()

  return useMemo(() => basePath || `/${entityNameModule}/${entityNamePlural.toLowerCase()}`, [basePath, entityNamePlural, entityNameModule])
}

export default function AddButton() {
  const { definitions: { entityName } } = useGrid()
  const path = useGridBasePath()

  return <HeaderAddButton to={`${path}/add`}>
    Add {entityName}
  </HeaderAddButton>
}
